<fieldmagic-dialog
  label="set_reason_lost"
  [instance]="this"
  icon="clipboard"
>
  <ng-template fieldmagicDialogButtonsTmp>
    <fieldmagic-primary-button
      purpose="save"
      (click)="onSave()"
    ></fieldmagic-primary-button>
  </ng-template>

  <ng-template fieldmagicDialogContentTmp>
    <div fieldmagicGridRow>
      <div fieldmagicGridColumn="12">
          <fieldmagic-dropdown-input
            [standalone]="true"
            [(ngModel)]="reason"
            bindValue="id"
            [options]="options"
          ></fieldmagic-dropdown-input>
      </div>

      <div
        *ngIf="showCompleteTasks$ | async"
        fieldmagicGridColumn="12"
        class="mt-2"
      >
        <fieldmagic-checkbox-input
          [(ngModel)]="markTasksAsComplete"
          label="Mark tasks as complete?"
        ></fieldmagic-checkbox-input>
      </div>
    </div>
  </ng-template>
</fieldmagic-dialog>
